/**
 * 完全自定义上报 可自定义上报通道和公共参数
 * @param {*} options
 *  spm_id : spmid 非必传 取meta中spmid
 *  CBlock : C段  非必传 默认 0
 *  DBlock : D段 非必传  默认 0
 *  type : pv, click, appear 上报类型通道
 * @param {*} info
 */
export const reportMsg = function (options = {}, info = {}) {
  const spm_idAB = options.spm_id ||  document.getElementsByTagName('meta').spm_prefix?.content || '0.0'
  const spmidC = options.c || options.CBlock || '0'
  const spmidD = options.d || options.DBlock || '0'
  const spm_id = `${spm_idAB}.${spmidC}.${spmidD}`
  if (!options.type) {
    throw new Error('report need type')
  }
  info.spm_id = spm_id
  if (window.reportObserver && window.reportObserver.reportCustomData) {
    window.reportObserver.reportCustomData(options.type, info)
  }
}

// 加载外部js
export function loadScript(src) {
  return new Promise(resolve => {
    const scriptEl = document.createElement('script')
    scriptEl.type = 'text/JavaScript'
    scriptEl.src = src
    scriptEl.onload = () => resolve()
    scriptEl.onreadystatechange = function() {
      if (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete') {
        resolve()
      }
    }
    document.body.appendChild(scriptEl)
  })
}

export function templateToString(str, data) {
  return str.replace(/{([^{}]+)}/g, (_, p) => {
    p = p.trim()
    return p && data[p] || ''
  })
}

export function getCookie(key) {
  return (
    decodeURIComponent(
        document.cookie.replace(
            new RegExp(
              // eslint-disable-next-line
                '(?:(?:^|.*;)\\s*' + encodeURIComponent(key).replace(/[\-\.\+\*]/g, '\\$&') +
            '\\s*\\=\\s*([^;]*).*$)|^.*$',
            ),
            '$1',
        ),
    ) || null
  )
}
